/**
 * Tutorial guidato delle Valute.
 *
 * Nessun preparativo: gli interruttori non si toccano, perche' salvano subito e
 * cambiano le valute con cui il sito espone i prezzi.
 */
const SCOPE = '[data-tour-scope="setting-currency"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createCurrencyTourSteps() {
	return [
		{
			body: "Le valute in cui il sito puo' mostrare i prezzi. I prezzi si scrivono una volta sola nella valuta di base: le altre sono conversioni, calcolate con il cambio indicato qui.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le valute',
		},
		{
			body: "Una riga per valuta, con il simbolo, il cambio rispetto alla valuta di base e l'interruttore. Il cambio e' il numero che fa la differenza: se resta fermo mentre i mercati si muovono, i prezzi nelle altre valute si allontanano piano piano da quello che volevi.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore accende la valuta sul sito, e salva subito. Perche' il visitatore possa davvero cambiarla serve anche che la multi valuta sia accesa nelle opzioni della pagina Layout: qui si dice quali valute esistono, li' se il selettore si vede.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: 'Accendere una valuta',
		},
		{
			body: "I tre puntini servono a rendere predefinita un'altra valuta: diventa la valuta di base e i cambi delle altre vengono riletti rispetto a lei. La predefinita non li ha.",
			key: 'row-menu',
			missing: 'skip',
			placement: 'right',
			target: at('row-menu'),
			title: 'Cambiare la valuta di base',
		},
	];
}
